import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/chart.type';
// Lib
import { SIZE_FULL } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';
import { Trans } from '@/components/tools/translation';

export const subscribersGrowthConfig: ChartType<typeof LineChart> = {
    title: 'chart.youtube.subscriber_growth',
    margin: { left: -20, right: 10 },
    name: {
        date: 'date',
        estimated: 'estimated_data',
        value: 'chart.youtube.subscriber_growth_name',
        evolution: 'evolution',
        avg: 'chart.youtube.subscriber_growth'
    },
    id: 'subscriber_growth',
    color: {
        value: 'blue',
        avg: 'gray',
        estimated: 'blue',
        unavailable: 'gray'
    },
    legendTypes: {
        value: 'line',
        unavailable: 'square'
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: (
        <Trans
            i18nKey="analytics:chart.youtube.tooltip_subscriber_growth"
            components={{ br: <br /> }}
        />
    ),
    size: SIZE_FULL,
    type: 'chart',
    noDataToken: 'no_data_period',
    element: LineChart
};
